import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=7538cbf7&scoped=true"
import script from "./Pay.vue?vue&type=script&lang=js"
export * from "./Pay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7538cbf7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7538cbf7')) {
      api.createRecord('7538cbf7', component.options)
    } else {
      api.reload('7538cbf7', component.options)
    }
    module.hot.accept("./Pay.vue?vue&type=template&id=7538cbf7&scoped=true", function () {
      api.rerender('7538cbf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/Pay.vue"
export default component.exports